import Sortable from "sortablejs";
import * as globals from "../../functions/globals";
import * as setters from "../setters";
import * as getters from "../getters";
import * as expand_rows from "./expand_rows";

export function addColvisReorder(instance, container, table) {
    instance.on('buttons-action', (e, buttonApi, dataTable, node, config) => {
        if (node.hasClass('buttons-colvis')) {
            setDraggableItemToColvisCollection(container);
            addColvisHeader(container);

            const colvisContainer = container.querySelector('.dt-button-collection .table-datatable-dropdown-items-container');

            Sortable.create(colvisContainer, {
                handle: '.colvis-draggable',
                animation: 300,
                ghostClass: 'colvis-put-place',
                onEnd: e => {
                    let left = parseInt(table.dataset.fixedColumnsLeft);
                    let from = e.oldIndex + left - 1;
                    let to = e.newIndex + left - 1;

                    instance.colReorder.move(from, to);
                    instance.state.save();
                    $(container).find(".dt-button-background").trigger("click");
                    instance.buttons(0).remove();
                    instance.button().add(0, {
                        extend: 'colvis',
                        columns: ':not(.noVis)'
                    });
                    setters.setNewColvisButton(container);
                    container.querySelector('.buttons-colvis').click();
                    expand_rows.hideUnnecessaryIcons();
                    // globals.adjustDatatableColumns();
                }
            });
        }
    })
}

export function addColvisHeader(container) {
    const colvisContainer = container.querySelector('.table-datatable-toolbar .table-datatable-colvis-place');
    colvisContainer.classList.add('dropdown-keep-open-on-click');
    const dropdown = colvisContainer.querySelector('.dropdown-menu');
    dropdown.classList.add('table-datatable-dropdown-items-container');

    if (!dropdown.querySelector('.table-datatable-button-colvis-header')) {
        dropdown.insertAdjacentHTML('afterbegin', `
            <div class="table-datatable-button-colvis-header">
                <h4>
                    ${Translator.__('Dostosuj kolumny')}
                    <button type="button" class="btn btn-link table-datatable-button-colvis-close" data-datatable="table-datatable-button-colvis-close">
                        <i class="fa fa-times"></i>
                    </button>
                </h4>
            </div>
        `);
    }
}

export function setDraggableItemToColvisCollection(container) {
    const draggableItem = '<i class="fa fa-bars ml-3 draggable-icon"></i>';
    const items = container.querySelectorAll('.dt-button.dropdown-item.buttons-columnVisibility');

    if (items) {
        items.forEach(item => {
            if (!item.classList.contains('colvis-draggable')) {
                item.classList.add('colvis-draggable');
            }

            if (!item.querySelector('.draggable-icon')) {
                item.insertAdjacentHTML('beforeend', draggableItem);
            }
        });
    }
}

export function initCloseColvisButton() {
    $('body').on('click', '[data-datatable="table-datatable-button-colvis-close"]', e => {
        const container  = getters.getContainer(e.target);

        $(container).find(".dt-button-background").trigger("click");
    });
}
